// source: design/src/pages/MESPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_ja';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-mes.jpg',
  heroTitle: '製造実行システム（MES）',
  heroTagline: '計画と実行を連携し、スマート製造を実現',
  intro: [
    'MES（Manufacturing Execution System）は、ERP計画層と現場実行層を連携させる核心情報システムであり、生産プロセスのリアルタイム可視化と精細管理を実現します。',
    'スマート製造の核心ハブとして、MESシステムは設備データをリアルタイムに収集し、生産進度を追跡し、資材の流れを管理し、製品品質を管理することで、生産の透明化、品質のトレーサビリティ、効率の最大化を支援します。',
    '飛狼は製造業界に長年深耕し、自動車、電子、食品、医薬品などの業界のお客様にMESシステムの計画、実装、統合サービスを提供します。',
  ],
  modules: [
    {
      icon: 'si/si-icons/route.svg',
      title: '工程追跡',
      desc: '各工程の加工状態、作業担当者、設備パラメータをリアルタイムに追跡し、全工程のトレーサビリティを実現します。',
    },
    {
      icon: 'si/si-icons/shield.svg',
      title: '品質管理',
      desc: 'SPC統計的工程制御、初品検査、不合格品処理、品質トレーサビリティにより、不良率を20%以上削減します。',
    },
    {
      icon: 'si/si-icons/cpu.svg',
      title: '設備連携',
      desc: 'OPC-UAプロトコルを通じてPLC、CNCなどの設備とリアルタイム通信し、OEEの重要データを収集します。',
    },
    {
      icon: 'si/si-icons/package.svg',
      title: '資材管理',
      desc: 'オンライン資材配送、Andonコール、資材ミス防止により、生産資材のタイムリーかつ正確な供給を保障します。',
    },
    {
      icon: 'si/si-icons/alert-triangle.svg',
      title: '異常管理',
      desc: 'リアルタイム異常アラート、エスカレーションの仕組み、異常処理のクローズドループ追跡を実現します。',
    },
    {
      icon: 'si/si-icons/file-text.svg',
      title: '電子バッチ記録',
      desc: '電子化された生産ロット記録を実現し、FDA 21 CFR Part 11などの規制要件を満たします。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/car.svg',
      title: '自動車製造',
      desc: '車両組み立てラインのリアルタイムティクト管理、部品トレーサビリティ、品質ゲート管理により、生産効率が15%以上向上します。',
    },
    {
      icon: 'si/si-icons/circuit-board.svg',
      title: '電子機器組立',
      desc: 'SMT実装工程制御、ESD管理、AOI連携により、スループットが99%以上に向上します。',
    },
    {
      icon: 'si/si-icons/utensils-crossed.svg',
      title: '食品・飲料',
      desc: '配合管理、ロットトレーサビリティ、HACCPコンプライアンスにより、食品の安全性と品質の均一性を保障します。',
    },
    {
      icon: 'si/si-icons/pill.svg',
      title: '医薬品製造',
      desc: '電子バッチ記録、GMPコンプライアンス、設備校正管理により、厳格な規制要件を満たします。',
    },
  ],
  benefits: [
    {
      number: '15-25%',
      title: '生産効率向上',
      desc: 'ライン切り替え時間の削減、生産ティクトの最適化、仕掛品在庫の削減',
    },
    {
      number: '20%',
      title: '不良率削減',
      desc: 'SPCリアルタイム監視、ミス防止メカニズム、全工程の品質トレーサビリティ',
    },
    {
      number: '10-15%',
      title: '設備OEE向上',
      desc: 'リアルタイムOEE収集、予測性保全、迅速な故障対応',
    },
    {
      number: '95%+',
      title: '納期遵守率',
      desc: '透明な生産進度、インテリジェントな生産計画、ボトルネックの早期警告',
    },
  ],
};
